<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        @if (modeService.isIosMode()) {
        <div>Abbrechen</div>
        } @if (!modeService.isIosMode()) {
        <div>
          <ion-icon
            name="close-outline"
            slot="icon-only"
            size="large"
          ></ion-icon>
        </div>
        }
      </ion-button>
    </ion-buttons>
    <ion-title>Rechnung</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="previewInvoice()" [disabled]="!this.invoiceForm.valid || !this.paymentForm.valid" [strong]="true"
        >Weiter</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <form
    [formGroup]="invoiceForm"
    class="bg-iosbackground dark:bg-transparent pt-5"
  >
    <ion-list>
      <ion-item lines="full" button (click)="selectStudent()" [disabled]="invoice() !== null" detail="true">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="person-outline"
            class="-mt-1 text-lg"
          ></ion-icon>
        </ion-note>
        <ion-label
          >{{
            invoiceForm.value.student_id.forename || "Fahrschüler auswählen"
          }}
          {{ invoiceForm.value.student_id.surname }}</ion-label
        >
      </ion-item>
      @if (isLoadingBalanceSignal() || isLoadingInvoiceItemsSignal() || isGeneratingInvoiceSignal()) {
        <ion-progress-bar type="indeterminate"></ion-progress-bar>
      }
      @if (invoicePaymentForm.value.student_balance > 0) {
        <ion-item id="open-toast" lines="none" class="flex justify-center h-8 flex-col-reverse">
          <ion-note slot="start">
            <ion-icon
              color="primary"
              name=""
              class="text-lg"
            ></ion-icon>
          </ion-note>
          <ion-text class="text-xs text-gray-500"
            >Guthaben aus Zahlungen: </ion-text>
          <ion-text class="text-xs text-gray-500" slot="end"
            >CHF {{ invoicePaymentForm.value.student_balance }}</ion-text
          >
          <ion-toast trigger="open-toast" message="Bei einem positiven Saldo werden vergangene, überschüssige Zahlungen automatisch der neuen Rechnung zugewiesen." [duration]="6000"></ion-toast>
        </ion-item>
      }
      @if (invoiceForm.value.student_id.subscription_lessons > 0) {
        <ion-item lines="none" class="flex justify-center h-8 flex-col-reverse">
          <ion-note slot="start">
            <ion-icon
              color="primary"
              name=""
              class="text-lg"
            ></ion-icon>
          </ion-note>
          <ion-text class="text-xs text-gray-500"
            >Guthaben aus Abo: </ion-text>
          <ion-text class="text-xs text-gray-500" slot="end"
            >{{ invoiceForm.value.student_id.subscription_lessons }} Lektionen</ion-text
          >
          <ion-toast trigger="open-toast" message="Bei einem positiven Saldo werden vergangene, überschüssige Zahlungen automatisch der neuen Rechnung zugewiesen." [duration]="6000"></ion-toast>
        </ion-item>
      }
    </ion-list>
    <ion-list class="mt-5 mb-5">
      <ion-item>
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="calendar-outline"
            class="text-lg -mt-1"
          ></ion-icon>
        </ion-note>
        <ion-input
          label="Datum"
          formControlName="date"
          placeholder="Datum"
          type="date"
        ></ion-input>
      </ion-item>
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="time-outline"
            class="text-lg -mt-1"
          ></ion-icon>
        </ion-note>
        <ion-select
          label="Zahlungsbedingung"
          formControlName="type"
          okText="Festlegen"
          cancelText="Abbrechen"
        >
          <ion-select-option [value]="0">Nach Erhalt</ion-select-option>
          <ion-select-option [value]="1">1 Tag</ion-select-option>
          <ion-select-option [value]="3">3 Tage</ion-select-option>
          <ion-select-option [value]="7">7 Tage</ion-select-option>
          <ion-select-option [value]="14">14 Tage</ion-select-option>
          <ion-select-option [value]="30">30 Tage</ion-select-option>
        </ion-select>
      </ion-item>
    </ion-list>
    <ion-item-divider>
      <ion-label>Positionen</ion-label>
      <ion-button
        mode="ios"
        class="m-0"
        fill="clear"
        slot="end"
        [disabled]="!invoiceForm.controls.student_id.value"
        (click)="getOpenInvoiceItems()"
      >
      <ion-text class="text-xs align-baseline">Ausstehende Leistungen</ion-text>
      <ion-icon class="ml-1" name="sync-outline"></ion-icon>
    </ion-button>
    </ion-item-divider>
    <ion-list class="mb-5">
      @for (item of invoiceForm.value.invoice_items; track item.id; let i = $index)
      {
      <ion-item button (click)="selectPosition(item)">
        @if (item.subscription_payment || isInTheFuture(item) || item.subscription_id) {
        <ion-note slot="start">
          <ion-icon [name]="isInTheFuture(item) ? 'play-forward-circle-outline' : item.subscription_id ? 'gift' : (item.prize === 0 && item.prize !== item.initial_prize) ? 'checkmark-circle' : (item.initial_prize !== item.prize) ? 'checkmark-circle-outline' : ''" class="text-lg -mt-1" (click)="showExplanation($event, item)"></ion-icon>
        </ion-note>
      }
        <div class="flex flex-col w-full">
          <div
            class="flex mt-2 h-6 flex-row items-center justify-between w-full"
          >
            <ion-text class="text-ellipsis">{{ item.name }}</ion-text>
            <ion-text class="w-40 text-end" type="number">{{
              twoDecimal(item.prize)
            }}</ion-text>
          </div>
          <div class="flex h-6 flex-row items-center justify-between w-full">
            <ion-text class="text-xs text-gray-500">{{
              item.date | date : "dd.MM.yyyy"
            }}</ion-text>
            <ion-text class="text-xs text-gray-500" type="number"
              >{{ item.amount }} {{ item.unit }}</ion-text
            >
          </div>
        </div>
        @if (!isItemInInvoice(item)) {
        <ion-button
          class="m-0"
          (click)="removeItem(item)"
          fill="clear"
          slot="end"
        >
          <ion-icon name="trash-outline"></ion-icon>
        </ion-button>
      }
      </ion-item>
      }
      <ion-item button (click)="selectPosition()" detail="true" lines="full">
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="add-outline"
            class="text-lg -mt-1"
          ></ion-icon>
        </ion-note>
        <ion-label>Position hinzufügen</ion-label>
      </ion-item>
    </ion-list>
    <form [formGroup]="paymentForm">
      <ion-item-divider>
        <ion-label>Zahlung</ion-label>
      </ion-item-divider>
      <ion-list class="mb-5" lines="none">
        @if (!includePayment) {
        <ion-item button (click)="addPayment()" detail="false">
          <ion-note slot="start">
            <ion-icon
              color="primary"
              name="add-outline"
              class="text-lg -mt-1"
            ></ion-icon>
          </ion-note>
          <ion-label>Zahlung hinzufügen</ion-label>
        </ion-item>
        } @else {
          <ion-row>
            <ion-col>
              <ion-item lines="full">
                <!-- one input field with default set to 0 and max input as total_amount of invoiceForm -->
                <ion-note slot="start">
                  <ion-icon
                    color="primary"
                    name="wallet-outline"
                    class="text-lg -mt-1"
                  ></ion-icon>
                </ion-note>
                <!-- side by side a select for the payment method and the actual amount paid (max is equal to the total_amount of the invoice and min is zero with default as 0) -->
                <ion-select
                  class="text-right"
                  formControlName="payment_method"
                  value="cash"
                  okText="Festlegen"
                  cancelText="Abbrechen"
                  aria-label="Zahlungsmethode"
                >
                  <ion-select-option value="Bar">Bar</ion-select-option>
                  <ion-select-option value="Bank">Bank</ion-select-option>
                  <ion-select-option value="Twint">Twint</ion-select-option>
                  <ion-select-option value="Kreditkarte">Kreditkarte</ion-select-option>
                </ion-select>
              </ion-item>
            </ion-col>
            <ion-col>
              <ion-item lines="full">
                <ion-input
                  class="text-right"
                  formControlName="payment"
                  (input)="updatePayment()"
                  type="number"
                  inputmode="decimal"
                  placeholder="0.00"
                  max="{{ invoiceForm.value.total_amount }}"
                  min="0"
                ></ion-input>
              </ion-item>
            </ion-col>
          </ion-row>
        }
      </ion-list>
    </form>
    <ion-item-divider>
      <ion-label>Rechnungsbetrag</ion-label>
    </ion-item-divider>
    <ion-list lines="indent">
      <ion-item>
        <ion-note slot="start">
          <ion-icon
            color="primary"
            name="cash-outline"
            class="text-lg -mt-1"
          ></ion-icon>
        </ion-note>
        <ion-text class="text-sm">Rechnungsbetrag</ion-text>
        <ion-text class="text-sm" slot="end"
          >CHF {{ twoDecimal(invoiceForm.value.total_amount) }}</ion-text
        >
      </ion-item>
      @for (openPayment of invoicePaymentForm.value.open_payments; track openPayment.payment_id) {
        <ion-item class="-mt-3" lines="indent">
          <ion-note slot="start">
            <ion-icon class="text-lg -mt-1"></ion-icon>
          </ion-note>
          <ion-text class="text-xs">Zahlung {{ openPayment.date | date: "dd.MM.yyyy" }}</ion-text>
          <ion-text class="text-xs" slot="end"
            >CHF {{ twoDecimal(openPayment.open_amount) }}</ion-text
          >
        </ion-item>
      }
      @if (paymentForm.value.payment > 0) {
        <ion-item class="-mt-3" lines="indent">
          <ion-note slot="start">
            <ion-icon class="text-lg -mt-1"></ion-icon>
          </ion-note>
          <ion-text class="text-xs">Zahlung {{ today | date: "dd.MM.yyyy" }}</ion-text>
          <ion-text class="text-xs" slot="end"
            >CHF {{ twoDecimal(paymentForm.value.payment) }}</ion-text
          >
        </ion-item>
      } @if (invoiceForm.value.student_id.subscription_lessons  > 0 && invoiceForm.value.student_id.subscription_lessons !== subscriptionLessons && invoiceForm.value.student_id.subscription_lessons > subscriptionLessons) {
        <ion-item lines="full">
          <ion-note slot="start">
            <ion-icon class="text-lg -mt-1"></ion-icon>
          </ion-note>
          <ion-text class="text-sm">Bezahlung mit Guthaben aus Abo</ion-text>
          @if (invoiceForm.value.student_id.subscription_lessons - subscriptionLessons; as paidLessons) {
            <ion-text class="text-sm" slot="end">{{ (paidLessons === 1) ? (paidLessons + ' Lektion') : (paidLessons + ' Lektionen') }}</ion-text
            >
          }
        </ion-item>
      }
      <ion-item lines="full">
        <ion-note slot="start">
          <ion-icon class="text-lg -mt-1"></ion-icon>
        </ion-note>
        <ion-text class="text-sm font-medium">Gesamtsumme</ion-text>
        <ion-text class="text-sm font-medium" slot="end"
          >CHF {{ twoDecimal(invoiceForm.value.amount) }}</ion-text
        >
      </ion-item>
      @if (paymentForm.controls?.payment.touched && paymentForm.controls?.payment.errors?.max) {
        <ion-item lines="full" class="flex justify-center h-8 flex-col-reverse">
          <ion-note slot="start">
            <ion-icon
              color="primary"
              name=""
              class="text-lg"
            ></ion-icon>
          </ion-note>
          <ion-text class="text-xs text-red-700"
            >Die Gesamtsumme darf nicht negativ sein.</ion-text
          >
        </ion-item>
      }
    </ion-list>
  </form>
  <div class="h-8"></div>
</ion-content>
